import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'

// import Index from './views/Index.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import(/* webpackChunkName: "entities" */ './views/Entities.vue'),
      meta: { auth: 'all' }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: { auth: false }
    },
    {
      path: '/entities',
      name: 'entities',
      component: () => import(/* webpackChunkName: "entities" */ './views/Entities.vue'),
      meta: { auth: true }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import(/* webpackChunkName: "map" */ './views/Map.vue'),
      meta: { auth: true }
    },
    {
      path: '/details/:entity',
      name: 'details',
      props: true,
      component: () => import(/* webpackChunkName: "details" */ './views/Details.vue'),
      meta: { auth: true }
    },
    {
      path: '/photos',
      name: 'photos',
      props: true,
      component: () => import(/* webpackChunkName: "photos" */ './views/Photos.vue'),
      meta: { auth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      props: true,
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dasboard.vue'),
      meta: { auth: 'admin' }
    },
    {
      path: '/users',
      name: 'users',
      props: true,
      component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
      meta: { auth: 'admin' }
    },
    {
      path: '/diff',
      name: 'diff',
      props: true,
      component: () => import(/* webpackChunkName: "diff" */ './views/Diff.vue'),
      meta: { auth: 'admin' }
    },
    {
      path: '/reminders',
      name: 'reminders',
      props: true,
      component: () => import(/* webpackChunkName: "reminders" */ './views/Reminders.vue'),
      meta: { auth: 'admin' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const auth = to.meta.auth || false
  if (auth) {
    const user = store.getters.user

    if (!user) {
      store.dispatch('login').then(usr => {
        proceed(usr)
      }).catch(err => {
        console.log(err)
        next({ name: 'login' })
      })
    } else {
      proceed(user, auth)
    }
  } else {
    next()
  }

  function proceed (user, auth) {
    const isAllowed = auth === 'admin' ? user && user.admin : user
    if (isAllowed) next()
    else next({ name: 'login' })
  }
})

export default router
